import { TApiResponse } from '@/common/types/response';

import { TProjectWithRegionsState } from './types';

export function setListOfProjects(
  state: TProjectWithRegionsState,
  res: TApiResponse<TProjectWithRegionsState['listOfProjects']>,
) {
  state.listOfProjects = res.data;
}

export function setProjectsWithForeignParticipationDatesCount(
  state: TProjectWithRegionsState,
  res: TApiResponse<TProjectWithRegionsState['projectsWithForeignParticipationDatesCount']>,
) {
  state.projectsWithForeignParticipationDatesCount = res.data;
}

export function setIsLoadingCount(state: TProjectWithRegionsState, isLoading: boolean) {
  state.isLoadingCount = isLoading;
}
